import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyViewportLock, cacheViewportLock, viewportLocked } from '../lib/viewportLock';

/**
 * Şemanın yakınlaştırma kilidini viewport etiketine yazar (bkz.
 * lib/viewportLock.js). İlk boyamayı `public/index.html` önbellekten yapar;
 * bu bileşen şema değiştiğinde, ilk ziyarette ve portal ile panel arasında
 * geçildiğinde kararı tazeler. Bağımlılıklar tek tek okunur: `settings`
 * nesnesi her yoklamada yenidir ve etiketi boşuna yeniden yazmamalıdır.
 */
const ViewportLock = ({ settings }) => {
  const { pathname } = useLocation();
  const siteTheme = settings?.site_theme;
  const adminDomainEnabled = settings?.admin_domain_enabled;
  const adminHost = settings?.admin_host;
  const adminDomainLocked = settings?.admin_domain_locked;

  useEffect(() => {
    const current = {
      site_theme: siteTheme,
      admin_domain_enabled: adminDomainEnabled,
      admin_host: adminHost,
      admin_domain_locked: adminDomainLocked,
    };
    applyViewportLock(viewportLocked(current, pathname));
    // Önbelleğe portalın kararı yazılır, bulunulan sayfanınki değil: panele
    // girip çıkan yöneticinin tarayıcısında portal kilitsiz açılmamalıdır
    // (index.html /admin yolunu zaten kendisi atlar).
    cacheViewportLock(viewportLocked(current, '/'));
  }, [siteTheme, adminDomainEnabled, adminDomainLocked, adminHost, pathname]);

  return null;
};

export default ViewportLock;
